
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import ServicesPage from '../pages/services/page';
import PricingPage from '../pages/pricing/page';
import BlogPage from '../pages/blog/page';
import ContactPage from '../pages/contact/page';
import NotFoundPage from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about-us',
    element: <AboutPage />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/plans-and-pricing',
    element: <PricingPage />
  },
  {
    path: '/bpo-blog',
    element: <BlogPage />
  },
  {
    path: '/contact-us',
    element: <ContactPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
